import { Component, OnInit, ViewChild } from '@angular/core';
import { PatientDashboardTabComponent } from 'src/app/patients/dashboard-page/dashboard-tab/dashboard-tab.component';
import { WARN } from 'src/app/global';
import { ToastService } from 'src/app/calvin-emr-shared/services/toast.service';
import { UntypedFormControl } from '@angular/forms';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';
import { DialogService } from 'primeng/dynamicdialog';
import { SchedulerWrapperComponent } from './medication-schedule/medication-schedule.component';
import { Store } from '@ngrx/store';
import { ButtonDirective } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { PrnScheduleComponent } from './prn-schedule/prn-schedule.component';
import { EmrInputComponent } from "../../../shared/emr-input/emr-input.component";

@Component({
  selector: 'app-mar-tab',
  templateUrl: './mar-tab.component.html',
  styleUrls: ['./mar-tab.component.scss'],
  providers: [DialogService],
  standalone: true,
  imports: [
    ButtonDirective,
    TabsModule,
    PrnScheduleComponent,
    EmrInputComponent,
    SchedulerWrapperComponent
  ],
})
export class MarTabComponent extends PatientDashboardTabComponent implements OnInit {
  /**
   * Flag indicating if the user has scanned the barcode of the patient.
   * This is set to true if the user is an admin.
   */
  isVerified: boolean;

  /**
   * The current patient's MRN.
   */
  wristbandId: UntypedFormControl = new UntypedFormControl('');

  patientMrn = '';

  @ViewChild('scheduleWrapper') scheduleWrapper!: SchedulerWrapperComponent;

  constructor(
    patientStore: PatientDashboardStore,
    store: Store,
    public dialogService: DialogService,
    private toastService: ToastService
  ) {
    super(patientStore, store);

    this.patient$.subscribe((patient: Patient) => {
      this.patientMrn = patient.mrn;
    });

    // Skip verifying patient if current user is admin
    this.isVerified = this.isAdmin;
  }

  ngOnInit(): void {
    this.stopLoading();
  }

  verify() {
    this.isVerified = this.patientMrn === this.wristbandIdFormControl.value;
    if (!this.isVerified) {
      this.toastService.clearAndAddOne({
        severity: WARN,
        detail: 'Wristband ID does not match patient MRN!',
        life: 3000,
      });
    }
  }

  loadMedicationsSchedule() {
    this.scheduleWrapper.addScheduler();
  }

  get wristbandIdFormControl(): UntypedFormControl {
    return this.wristbandId;
  }
}
